/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findOrCreateFormCustom } from '../fn/form-custom/find-or-create-form-custom';
import { FindOrCreateFormCustom$Params } from '../fn/form-custom/find-or-create-form-custom';
import { FormCustom } from '../models/form-custom';
import { updateFormCustom } from '../fn/form-custom/update-form-custom';
import { UpdateFormCustom$Params } from '../fn/form-custom/update-form-custom';

@Injectable({ providedIn: 'root' })
export class FormCustomService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formCustomControllerFindOrCreateFormCustom()` */
  static readonly FormCustomControllerFindOrCreateFormCustomPath = '/forms/{formId}/custom';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOrCreateFormCustom()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOrCreateFormCustom$Response(
    params: FindOrCreateFormCustom$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormCustom>> {
    return findOrCreateFormCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOrCreateFormCustom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOrCreateFormCustom(params: FindOrCreateFormCustom$Params, context?: HttpContext): Observable<FormCustom> {
    return this.findOrCreateFormCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormCustom>): FormCustom => r.body)
    );
  }

  /** Path part for operation `formCustomControllerUpdateFormCustom()` */
  static readonly FormCustomControllerUpdateFormCustomPath = '/forms/{formId}/custom/{formCustomId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormCustom$Response(
    params: UpdateFormCustom$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormCustom>> {
    return updateFormCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFormCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormCustom(params: UpdateFormCustom$Params, context?: HttpContext): Observable<FormCustom> {
    return this.updateFormCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormCustom>): FormCustom => r.body)
    );
  }
}
